import React, { FC } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

type Props = { loading: boolean } & ButtonProps;

const LoadingButton: FC<Props> = ({ loading, children, ...rest }) => {
  return (
    <Button data-testid="loading-button" disabled={loading || rest.disabled} {...rest}>
      <Box sx={{ position: 'relative' }}>
        {loading && <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <CircularProgress style={{ color: 'white' }} size={16} data-testid="loading-button-spinner" />
        </Box>}
        <Box sx={{ opacity: loading ? 0 : 1 }}>{children}</Box>
      </Box>
    </Button>
  );
};

export default LoadingButton;
